// Checkout / order / contact helpers.
// Orders are created SERVER-SIDE by the createCheckoutSession Cloud Function
// (it re-prices the cart, checks stock, validates the promo, and returns a
// Stripe Checkout URL). The client never sets prices or order numbers.
import { httpsCallable } from "firebase/functions";
import { doc, getDoc, addDoc, collection, serverTimestamp } from "firebase/firestore/lite";
import { functions, db } from "./firebase";

/**
 * @param {{items:{productId:string,qty:number}[], customer:object, recipient:object,
 *          delivery:object, promoCode?:string}} payload
 * @returns {Promise<{url:string, orderId:string, orderNumber:string}>}
 */
export async function startCheckout(payload) {
  const fn = httpsCallable(functions, "createCheckoutSession");
  const res = await fn({ ...payload, origin: window.location.origin });
  return res.data;
}

export async function fetchOrderById(orderId) {
  if (!orderId) return null;
  const s = await getDoc(doc(db, "orders", orderId));
  return s.exists() ? { id: s.id, ...s.data() } : null;
}

export async function submitContactMessage(data) {
  await addDoc(collection(db, "contactMessages"), { ...data, at: serverTimestamp() });
}

/**
 * Public order tracking (scope §3/§10). Requires BOTH order number and the
 * matching email — verified server-side by the trackOrder Cloud Function.
 * @returns {Promise<{orderNumber,paymentStatus,deliveryStatus,items,total,delivery,recipient,...}>}
 */
export async function trackOrder({ orderNumber, email }) {
  const fn = httpsCallable(functions, "trackOrder");
  const res = await fn({ orderNumber, email });
  return res.data;
}
